export default __webpack_public_path__ + "static/media/i118hp.59380add.webp";